var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSelectedShowcaseLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 52,
    viewBox: "0 0 24 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 52C13.6569 52 15 50.6569 15 49C15 47.3431 13.6569 46 12 46C10.3431 46 9 47.3431 9 49C9 50.6569 10.3431 52 12 52Z",
    fill: "#9698F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1032 20.8172C11.4701 20.0739 12.5299 20.0739 12.8967 20.8172L14.9873 25.0533C15.133 25.3484 15.4146 25.553 15.7403 25.6003L20.4151 26.2796C21.2353 26.3988 21.5628 27.4068 20.9693 27.9853L17.5866 31.2826C17.3509 31.5124 17.2433 31.8434 17.299 32.1678L18.0975 36.8237C18.2376 37.6406 17.3802 38.2635 16.6466 37.8779L12.4653 35.6796C12.174 35.5265 11.826 35.5265 11.5346 35.6796L7.35333 37.8779C6.6197 38.2635 5.76227 37.6406 5.90238 36.8237L6.70093 32.1678C6.75657 31.8434 6.64902 31.5124 6.41333 31.2826L3.03062 27.9853C2.4371 27.4068 2.76461 26.3988 3.58483 26.2796L8.25963 25.6003C8.58534 25.553 8.86691 25.3484 9.01257 25.0533L11.1032 20.8172Z",
    fill: "#585B63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72201 22.6517L4.2002 21.1299",
    stroke: "#585B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2783 22.6523L19.8001 21.1305",
    stroke: "#585B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9678 41.2061V39.0539",
    stroke: "#585B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.99707 34.5947L2.9476 33.6852",
    stroke: "#585B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0032 34.5951L21.0527 33.6855",
    stroke: "#585B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectedShowcaseLight);
export default __webpack_public_path__ + "static/media/ic_selected_showcase_light.735ae7a370126f91bfc71aacd95f7784.svg";
export { ForwardRef as ReactComponent };